module.exports = __webpack_public_path__ + "img/free-data.c985b104.png";